import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

import TicketsManagerTabs from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";

import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

const useStyles = makeStyles(() => ({
    content: {
        overflow: "hidden",
        minHeight: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
}));

const TicketAdvanced = () => {
    const classes = useStyles();
    const { ticketId } = useParams();
    const { setCurrentTicket } = useContext(TicketsContext);
    const inConversation = Boolean(ticketId && ticketId !== "undefined");

    useEffect(() => {
        return () => {
            setCurrentTicket({ id: null, code: null });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <QueueSelectedProvider>
            <TicketAdvancedLayout>
                <Box className={classes.content}>
                    {inConversation ? <Ticket /> : <TicketsManagerTabs />}
                </Box>
            </TicketAdvancedLayout>
        </QueueSelectedProvider>
    );
};

export default TicketAdvanced;
